<template>
  <div class="monitor-dashbord">
    <div class="bord">
      <div class="left">
        <div class="graph-dash" ref="graphRef"></div>

        <!-- 视频监控区域 -->
        <div class="video-section">
          <div class="section-title">车间实时监控画面</div>
          <div class="video-grid video">
            <template v-if="cameras.length">
              <div
                v-for="(item, index) in cameras"
                :key="`${index}-${curCell ? curCell.id : 'no-cell'}`"
                class="video-item item"
              >
                <div class="video-title">镜头{{ index + 1 }} - {{ item.name }}</div>
                <div class="video-player-container-box">
                  <template v-if="item.deviceNum">
                    <CustomPlayer ref="customPlayerRefs" :dev-num="item.deviceNum" :croping="false" />
                  </template>
                  <template v-else>
                    <div class="no-video"></div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="monitor-info">
        <div class="workshop">
          <div class="blue-title">选择工厂-车间</div>
          <div class="querry-params">
            <el-select v-model="factory" filterable placeholder="请选择工厂" class="factory" @change="factoryChange">
              <el-option
                v-for="(item, index) in factoryOptions"
                :key="`index${index}`"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
            <el-select v-model="workShop" filterable placeholder="请选择车间" @change="shopChange">
              <el-option
                v-for="(item, index) in workShopList"
                :key="`index${index}`"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </div>

          <div class="infors">
            <div v-for="(item, infoIndex) in bizDevices" :key="`index${infoIndex}`" class="info-item">
              <div :class="['infoImg', `infoImg${item.dictValue}`]"></div>
              <div class="label">{{ item.dictLabel }}</div>
            </div>
          </div>

          <div class="enum-status">
            <div
              :class="['status', `status${statusItme.value}`]"
              v-for="(statusItme, itemIndex) in statusEnum"
              :key="`itemIndex${itemIndex}`"
            >
              <span>{{ statusItme.key }} ：</span>
              <span>{{ statusItme.label }}</span>
            </div>
          </div>
        </div>

        <div class="monitor-detail">
          <div class="blue-title">
            <span>场景监控数据详情</span>
          </div>
          <div class="sub-title">显示场景：{{ curcellInfo?.sceneName }}</div>

          <div class="details">
            <template v-for="(item, index) in curcellInfo?.scenePointInfoList">
              <!-- 只展示有设备的 -->
              <div v-if="item.deviceId" :key="`index${index}`" class="info-item">
                <div :class="['detailImg', `infoImg${item?.pointType}`, `status${item?.deviceData?.status}`]"></div>
                <div class="iteminfos">{{ item.deviceNum || '' }}</div>
                <div v-if="item.deviceData" :key="item.id" class="iteminfos">
                  <div v-for="(val, valIndex) in item?.deviceData.data" :key="`index${valIndex}`">
                    <span>{{ val.name }}：</span>
                    <span>{{ val.value }}</span>
                    <span>{{ val.unit }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Graph, Node } from '@antv/x6';
import { Selection } from '@antv/x6-plugin-selection';
import request from '@/utils/request';
import api from '@/utils/api';
import CustomPlayer from '@/components/customPlayer.vue';

import mpegts from 'mpegts.js';

import { mapState } from 'vuex';

export default {
  data() {
    return {
      graph: null,
      infos: [1, 2, 3, 4, 5, 6, 7],
      factory: '',
      workShop: '',
      factoryOptions: [],
      workShopList: [],
      sceneJson: {},
      curCell: null,
      bizDevices: [],
      cameras: [],
      curcellInfo: null,
      statusEnum: {
        1: {
          key: '绿色',
          label: '正常',
          color: '#1ecb80',
          value: '1'
        },
        2: {
          key: '红色',
          label: '报警',
          color: '#ff8686',
          value: '2'
        },
        3: {
          key: '灰色',
          label: '掉线',
          color: '#898989',
          value: '3'
        }
      },
      refreshTimer: null
    };
  },
  components: {
    CustomPlayer
  },
  computed: {
    ...mapState('login', ['tenantId']) // 'auth' 是你的模块名称，根据实际情况调整
  },
  mounted() {
    this.initGraph();
    this.getFactoryList();
    this.getBizSceneType();
  },
  watch: {
    // 当isFlod变化时，这个函数就会被调用
    curCell(newValue, oldValue) {
      if (newValue?.id !== oldValue?.id) {
        this.cameras = [];
        let camerasTem = [];
        const found = this.workshopSceneLayoutData.find((scene) => scene.cellId === newValue?.id);
        if (found) {
          this.curcellInfo = found;
          if (found.scenePointInfoList.length) {
            camerasTem =
              found.scenePointInfoList
                .filter((item) => item.pointType === 1 && item.deviceId)
                .map((item) => {
                  return {
                    name: item.deviceName,
                    src: '',
                    deviceNum: item.deviceNum,
                    playing: false,
                    muted: false,
                    volume: 1,
                    player: null
                  };
                }) || [];
          } else {
            this.cameras = [];
          }
        }
        if (camerasTem.length < 2) {
          this.cameras = Array.from({ length: 2 }, (_, i) => {
            if (i < camerasTem.length) {
              return {
                ...camerasTem[i]
              };
            } else {
              return {
                name: '暂无视频'
              };
            }
          });
        } else {
          this.cameras = camerasTem;
        }
      }
    }
  },
  methods: {
    // 获取所有视频播放状态
    getAllVideoPlayingStates() {
      if (!this.$refs.customPlayerRefs) return false;

      const players = Array.isArray(this.$refs.customPlayerRefs)
        ? this.$refs.customPlayerRefs
        : [this.$refs.customPlayerRefs];

      return players.some((player) => player.playing && player.$el && player.$el.offsetParent !== null);
    },
    // 新增：启动自动刷新
    startAutoRefresh() {
      // 如果有视频播放则不刷新

      if (this.getAllVideoPlayingStates()) {
        return;
      }
      // 先清除可能存在的旧定时器
      this.clearAutoRefresh();

      // 创建新定时器，每30秒刷新一次
      this.refreshTimer = setInterval(() => {
        if (this.workShop) {
          this.getSceneLayout();
        }
      }, 30000); // 30秒 = 30000毫秒
    },
    // 新增：清除自动刷新
    clearAutoRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
    beforeDestroy() {
      // 新增：组件销毁前清除定时器
      this.clearAutoRefresh();
      if (this.graph) {
        this.graph.dispose(); // 组件销毁前清理图形实例
      }
    },
    // 获取场景类型
    getBizSceneType() {
      request
        .get(`${api.pointManagement.getBizDeviceName}`)
        .then((res) => {
          if (res.code === 200) {
            this.bizDevices = (res.data || []).map((item) => {
              return {
                dictCode: item.dictCode,
                dictLabel: item.dictLabel,
                dictValue: item.dictValue
              };
            });
          } else {
            this.bizDevices = [];
          }
        })
        .catch((err) => {
          this.bizDevices = [];
        });
    },
    factoryChange() {
      this.workShop = '';
      this.getWorkShopList();
    },
    shopChange() {
      this.getSceneLayout();
    },
    // 查询车间
    getWorkShopList() {
      request
        .get(`${api.dropdownList.workshopList}`, {
          params: {
            // 这是 GET 请求的标准传参方式
            factoryId: this.factory
          }
        })
        .then((res) => {
          if (res.code === 200 && res?.data?.length) {
            this.workShopList = (res.data || []).map((item) => {
              return {
                label: item.name,
                value: item.id
              };
            });
            if (this.workShopList.length) {
              this.workShop = this.workShopList[0].value;
              this.getSceneLayout();
              this.startAutoRefresh();
            }
          } else {
            this.workshopOptions = [];
          }
        })
        .catch((err) => {
          this.workshopOptions = [];
        });
    },
    // 查询工厂
    getFactoryList() {
      request
        .get(`${api.dropdownList.factoryList}`, {
          params: {
            tenantId: '00'
          }
        })
        .then((res) => {
          if (res.code === 200 && res?.data?.length) {
            this.factoryOptions = (res.data || []).map((item) => {
              return {
                label: item.name,
                value: item.id
              };
            });

            if (this.factoryOptions.length) {
              this.factory = this.factoryOptions[0].value;
              this.getWorkShopList();
            }
          } else {
            this.factoryOptions = [];
          }
        })
        .catch((err) => {
          this.factoryOptions = [];
        });
    },
    initGraph() {
      this.graph = new Graph({
        container: this.$refs.graphRef,

        panning: {
          // 禁用画布拖拽
          enabled: false // 关闭画布平移
        },
        interacting: {
          // 控制交互行为
          nodeMovable: false,
          stopScrollOnTouchStart: false
        },
        mousewheel: {
          enabled: false, // 启用滚轮缩放
          zoomAtMousePosition: false, // 以鼠标位置为中心缩放
          modifiers: [], // 无需按修饰键（默认需要按ctrl）
          minScale: 0.5, // 最小缩放比例
          maxScale: 3, // 最大缩放比例
          zoomFactor: 0.1 // 缩放速度
        },
        background: {
          color: '#F2F7FA'
        }
      });

      this.graph.use(
        new Selection({
          enabled: true, // 开启选择功能
          movable: false, // 在选择插件中禁用移动
          rubberband: false, // 启用框选
          multiple: false, // 允许多选（按住 Ctrl/Cmd）
          movable: false, // 选中节点可拖动
          strict: false, // 框选时部分重叠即选中（true 需完全包含）
          showNodeSelectionBox: false, // 显示节点选中框
          className: 'my-selecting',
          pointerEvents: 'none' // 避免遮挡事件:cite[7]:cite[10]
        })
      );

      // this.graph.on('cell:click', this.cellFn);

      this.graph.on('node:selected', ({ node }) => {
        // 设置选中样式

        // 设置选中样式
        this.applySelectedStyle(node);

        // 更新当前选中节点
        if (node.isNode() && node.getData().isParent) {
          this.curCell = node;
        }
        if (node.isNode() && node.getParent()) {
          this.curCell = node.getParent();
        }
      });

      this.graph.on('node:unselected', ({ node }) => {
        if (this.curCell === node) {
          this.curCell = null;
        }
        // 恢复原始样式
        this.resetNodeStyle(node);
      });

      this.graph.on('blank:click', () => {
        // 清空选中

        // this.graph.cleanSelection();

        // 清空当前节点引用

        this.curCell = null;
      });

      this.graph.on('scale', () => {
        const nodes = this.graph.getNodes();
        this.adjustFixedElements(nodes);
      });
    },
    adjustFixedElements(nodes) {
      nodes.forEach((node) => {
        if (node.isNode()) {
          const data = node.getData();

          // 设备节点保持固定大小
          if (node.getParent() || data.deviceId) {
            // 设置固定大小，不受缩放影响
            node.resize(10, 10);
            node.attr('body', { strokeWidth: 0.2 });
          }

          if (data.isParent) {
            node.attr('label', {
              style: {
                'font-size': '7px',
                'white-space': 'nowrap'
              }
            });
          }
        }
      });
    },
    cellFn({ e, cell }) {
      e.stopPropagation();

      // 更新当前选中节点
      this.cameras = [];
      this.curCell = cell;
    },
    // 获取场景图
    getSceneLayout() {
      const selectedCellId = this.curCell?.id;
      request
        .get(`${api.monitorDashbord.getWorkShopLayout}/${this.workShop}`)
        .then((res) => {
          if (res.code === 200) {
            const { workshopSceneLayoutData, workshopSceneLayoutJsonStr } = res.data;
            if (workshopSceneLayoutData) {
              this.sceneJson = JSON.parse(workshopSceneLayoutJsonStr);
              this.workshopSceneLayoutData = workshopSceneLayoutData || [];
              const cells = this.sceneJson.cells;

              if (this.graph && cells.length) {
                for (let i = 0; i < cells.length; i++) {
                  let cell = cells[i];

                  for (let i = 0; i < this.workshopSceneLayoutData.length; i++) {
                    let scene = this.workshopSceneLayoutData[i];
                    if (scene.scenePointInfoList.length) {
                      for (let j = 0; j < scene.scenePointInfoList.length; j++) {
                        let point = scene.scenePointInfoList[j];
                        let fondPointCell = cells.find((cell) => point.cellId === cell.id);
                        if (fondPointCell) {
                          fondPointCell.data = point;
                        }
                      }
                    }
                  }
                }
              }

              this.graph.fromJSON(this.sceneJson); // 渲染元素
              const nodes = this.graph.getNodes();
              // 更新节点样式
              this.updataNodesStyle(nodes);
              this.graph.centerContent(); // 居中显示
              this.zoomToFit();

              if (selectedCellId) {
                const previousSelectedNode = nodes.find((node) => node.id === selectedCellId);
                if (previousSelectedNode) {
                  // 先清除其他选中
                  this.graph.cleanSelection();

                  // 手动设置选中样式
                  this.applySelectedStyle(previousSelectedNode);

                  // 选中节点
                  this.graph.select(previousSelectedNode);
                  this.curCell = previousSelectedNode;
                }
              } else {
                // 如果没有之前选中的节点，选中第一个父节点
                let firstParentNode = null;
                for (let i = 0; i < nodes.length; i++) {
                  const node = nodes[i];
                  if (node.isNode() && node.getData().isParent) {
                    firstParentNode = node;
                    break;
                  }
                }
                if (firstParentNode) {
                  // 先清除其他选中
                  this.graph.cleanSelection();

                  // 手动设置选中样式
                  this.applySelectedStyle(firstParentNode);

                  // 选中节点
                  this.graph.select(firstParentNode);
                  this.curCell = firstParentNode;
                }
              }
            } else {
              this.sceneJson = {};
              this.graph.fromJSON(this.sceneJson); // 渲染元素
            }
          } else {
            this.sceneJson = {};
            this.graph.fromJSON(this.sceneJson); // 渲染元素
          }
        })
        .catch((err) => {
          this.sceneJson = {};
          this.graph.fromJSON(this.sceneJson); // 渲染元素
        });
    },
    // 更行节点样式
    // 更新节点样式
    updataNodesStyle(nodes) {
      let danger = '#ff8686';
      let health = '#1ecb80';
      let leave = '#898989';
      let noDeviceColor = '#8f8f8f'; // 没有设备的颜色
      let deviceColor = '#7719aa'; // 绑定设备的颜色
      nodes.forEach((node) => {
        // 3. 检查是否为节点（现在使用正确的图形对象）
        if (node.isNode()) {
          // 如果是节点且是子节点，查询
          if (node.isNode() && node.getParent()) {
            const data = node.getData();

            if (data.pointId && data?.deviceId && data?.deviceData?.status === 1) {
              node.attr('body/fill', health);
              node.attr('body/stroke', this.health);
            } else if (data.pointId && data?.deviceId && data?.deviceData?.status === 2) {
              node.attr('body/fill', danger);
              node.attr('body/stroke', danger);
            } else if (data.pointId && data?.deviceId && data?.deviceData?.status === 3) {
              node.attr('body/fill', leave);
              node.attr('body/stroke', leave);
            } else if (data.pointId && data?.deviceId && !data?.deviceData?.status) {
              // 绑定了设备 没有设备状态
              node.attr('body/fill', leave);
              node.attr('body/stroke', leave);
            } else {
              // 没有绑定设备 清除设备
              // node.attr('body/fill', noDeviceColor);
              // node.attr('body/stroke', noDeviceColor);
              this.graph.removeNode(node);
            }

            if (data.pointType === 1) {
              node.attr('body/fill', health);
              node.attr('body/stroke', this.health);
            }
          }
        }
      });
    },
    // 新增方法：手动应用选中样式
    applySelectedStyle(node) {
      if (node.isNode() && node.getData().isParent) {
        // 父节点选中样式
        node.attr('body/fill', '#CEE2FF');
        node.attr('body/stroke', '#CEE2FF');
      }

      if (node.isNode() && node.getParent()) {
        const parentNode = node.getParent();
        // 子节点对应的父节点选中样式
        parentNode.attr('body/fill', '#CEE2FF');
        parentNode.attr('body/stroke', '#CEE2FF');
      }
    },
    // 新增方法：恢复节点原始样式
    resetNodeStyle(node) {
      if (node.isNode() && node.getData().isParent) {
        const originalStyle = node.getData()?.originalStyle;
        if (originalStyle) {
          node.attr('body/fill', originalStyle.fill);
          node.attr('body/stroke', originalStyle.stroke);
        } else {
          // 默认恢复样式
          node.attr('body/fill', '#FFFFFF');
          node.attr('body/stroke', '#595959');
        }
      }

      if (node.isNode() && node.getParent()) {
        const parentNode = node.getParent();
        const originalStyle = parentNode.getData()?.originalStyle;
        if (originalStyle) {
          parentNode.attr('body/fill', originalStyle.fill);
          parentNode.attr('body/stroke', originalStyle.stroke);
        } else {
          parentNode.attr('body/fill', '#FFFFFF');
          parentNode.attr('body/stroke', '#595959');
        }
      }
    },
    zoomToFit() {
      this.graph.zoomToFit({
        padding: 10,
        maxScale: 100,
        minScale: 0.5,
        allowNewOrigin: 'any',
        contentArea: true,
        useCellGeometry: true
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.monitor-dashbord {
  height: calc(100vh - 40px);
  overflow: auto;
  .title-box {
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    padding: 27px 0 15px;
    line-height: 16px;
  }

  .blue-title {
    padding-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 2px;
    font-size: 14px;
    &::before {
      content: '';
      display: block;
      width: 3px;
      height: 17px;
      background-color: #3083fb;
      margin-right: 4px;
    }
  }

  .monitor-info {
    width: 400px;
  }
  .bord {
    margin-top: 10px;
    display: flex;
    height: calc(100% - 10px);
    width: 100%;
    display: flex;
    overflow: auto;
    .left {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    .workshop {
      padding: 10px;
      margin-bottom: 18px;
      width: 100%;
      background: #f2f8ff;
      border-radius: 8px;
      box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);

      .querry-params {
        display: flex;
        flex-wrap: nowrap;
      }

      .el-select {
        width: calc((100% - 10px) / 2);
        margin-bottom: 10px;

        &:nth-child(1) {
          margin-right: 10px;
        }
      }

      .infors {
        display: flex;
        flex-wrap: wrap;
        .info-item {
          width: calc((100% - 10px) / 2);
          display: flex;
          justify-content: flex-start;
          padding: 6px 0;
          font-size: 12px;
          line-height: 16px;
          &:nth-child(2n + 1) {
            margin-right: 10px;
          }

          .infoImg {
            width: 16px;
            height: 16px;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-right: 20px;
            &.infoImg2 {
              background-image: url('@/assets/images/point-pressure-blue.svg');
            }
            &.infoImg1 {
              background-image: url('@/assets/images/point-camera--blue.svg');
            }
            &.infoImg3 {
              background-image: url('@/assets/images/point-air-particles-blue.svg');
            }
            &.infoImg5 {
              background-image: url('@/assets/images/point-Temperature-blue.svg');
            }
            &.infoImg4 {
              background-image: url('@/assets/images/ponit-ozone-concentration-blue.svg');
            }
            &.infoImg7 {
              background-image: url('@/assets/images/point-calculate-box-blue.svg');
            }
          }

          .label {
            text-align: left;
          }
        }
      }

      .enum-status {
        margin: 10px 0;
        line-height: 16px;
        font-size: 12px;
        font-weight: bold;
        display: flex;
        .status {
          margin-left: 10px;
        }

        .status1 {
          color: #1ecb80;
        }
        .status2 {
          color: #ff8686;
        }
        .status3 {
          color: #898989;
        }
      }
    }
    .graph-dash {
      height: 58%;
      min-height: 58%;
      border: 1px solid #ccc;
      margin-right: 10px;
      border-radius: 8px;
    }

    .monitor-detail {
      width: 100%;
      min-height: calc(100% - 229px);
      padding: 10px;
      background: #f5fff9;
      box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;

      .title {
        font-size: 16px;
        font-weight: bold;
        text-align: left;
      }

      .sub-title {
        font-size: 12px;
      }

      .details {
        .info-item {
          display: flex;
          justify-content: flex-start;
          margin: 8px 0;
          font-size: 12px;
          line-height: 16px;

          .detailImg {
            width: 16px;
            height: 16px;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-right: 20px;
            &.infoImg2 {
              background-image: url('@/assets/images/point-pressure-blue.svg');
              &.status1 {
                background-image: url('@/assets/images/point-pressure-green.svg');
              }
              &.status2 {
                background-image: url('@/assets/images/point-pressure-red.svg');
              }
              &.status3 {
                background-image: url('@/assets/images/point-pressure-gray.svg');
              }
            }
            &.infoImg1 {
              background-image: url('@/assets/images/point-camera--blue.svg');
              &.status1 {
                background-image: url('@/assets/images/point-camera-green.svg');
              }
              &.status2 {
                background-image: url('@/assets/images/point-camera-red.svg');
              }
              &.status3 {
                background-image: url('@/assets/images/point-camera-gray.svg');
              }
            }
            &.infoImg3 {
              background-image: url('@/assets/images/point-air-particles-blue.svg');
              &.status1 {
                background-image: url('@/assets/images/point-air-particles-green.svg');
              }
              &.status2 {
                background-image: url('@/assets/images/point-air-particles-red.svg');
              }
              &.status3 {
                background-image: url('@/assets/images/point-air-particles-gray.svg');
              }
            }
            &.infoImg5 {
              background-image: url('@/assets/images/point-Temperature-blue.svg');
              &.status1 {
                background-image: url('@/assets/images/point-Temperature-green.svg');
              }
              &.status2 {
                background-image: url('@/assets/images/point-Temperature-red.svg');
              }
              &.status3 {
                background-image: url('@/assets/images/point-Temperature-gray.svg');
              }
            }
            &.infoImg4 {
              background-image: url('@/assets/images/ponit-ozone-concentration-blue.svg');
              &.status1 {
                background-image: url('@/assets/images/ponit-ozone-concentration-green.svg');
              }
              &.status2 {
                background-image: url('@/assets/images/ponit-ozone-concentration-red.svg');
              }
              &.status3 {
                background-image: url('@/assets/images/ponit-ozone-concentration.svg');
              }
            }
            &.infoImg7 {
              background-image: url('@/assets/images/calculate-box-blue.svg');
              &.status1 {
                background-image: url('@/assets/images/calculate-box-green.svg');
              }
              &.status2 {
                background-image: url('@/assets/images/calculate-box-red.svg');
              }
              &.status3 {
                background-image: url('@/assets/images/calculate-box-gray.svg');
              }
            }
          }

          .iteminfos {
            padding-right: 10px;
          }
        }
      }
    }
  }

  .video-section {
    flex: 1;
    .section-title {
      padding-top: 10px;
      font-weight: bold;
      font-size: 12px;
    }
  }

  .video-grid {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-start;

    .video-title {
      height: 20px;
      line-height: 20px;
      font-size: 8px;
      padding-left: 10px;
      text-align: left;
      width: 100%;
      background-color: #4f5566;
      color: #fff;
    }

    .video-item {
      height: 245px;
      width: calc((100% - 20px) / 2);
      border: 1px solid #ccc;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      margin-top: 10px;
      margin-right: 10px;
      border-radius: 8px;
      overflow: hidden;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }

  .video-player-container-box {
    width: 100%;
    height: calc(100% - 20px);
    cursor: pointer;
    background: #000;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    .no-video {
      width: 108px;
      height: 108px;
      background: url('@/assets/images/no-video.png') no-repeat center center;
      cursor: not-allowed;
    }

    &:hover {
      .volume-control-wrapper {
        opacity: 1;
      }

      .player-controls {
        opacity: 1;
      }
    }
  }

  .video-player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .vertical-volume-container {
    display: flex;
    align-items: flex-end;
    padding: 8px 5px;
    border-radius: 20px;
    position: relative;
    height: 120px; /* 固定高度 */

    &:hover {
      .vertical-volume-slider {
        opacity: 1;
      }
    }
  }

  .volume-icon {
    color: white;
    font-size: 20px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: scale(1.1);
    }
  }

  .vertical-volume-slider {
    -webkit-appearance: none;
    width: 6px;
    height: 100px;
    background: linear-gradient(to top, #4a90e2, #1ecb80); /* 渐变轨道，从下到上 */
    border-radius: 3px;
    outline: none;
    opacity: 0;
    transform: rotate(0deg); /* 不需要旋转180度了 */
    writing-mode: bt-lr;
    -webkit-appearance: slider-vertical;
    margin-left: 10px;
    margin-bottom: 6px;

    /* 滑块手柄样式 */
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: white;
      cursor: pointer;
      margin-top: -8px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.2);
      }
    }
  }

  .control-btn {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 16px;
    margin: 0 15px;
    padding: 5px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    transition: background 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }

    &.fullscreen-btn {
      margin-right: 68px;
    }
  }

  .player-controls {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    opacity: 0;
    padding: 10px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    transition: opacity 0.3s;
    z-index: 10;

    .play-tools {
      display: flex;
      align-items: center;
      position: relative;

      /* 垂直音量控制区域 */
      .volume-control-wrapper {
        margin-right: 10px;
        position: absolute;
        right: 0;
        top: -80px;
        transition: opacity 0.3s;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
</style>
